export default "__VITE_ASSET__CDLv0uPo__"